module.exports = __webpack_public_path__ + "static/media/about.51ac5ee4.jpg";